<div class="flex flex-col">
    <div class="relative flex justify-center my-8 mt-4">
        <img alt="..." src="../../../../../assets/img/{{city}}.jpg" class="w-1/5 h-1/5 rounded-full" />
        <h2 class="my-2 absolute bottom-0 font-light leading-relaxed text-2xl text-yellow-200 cursor-default">{{city}}
        </h2>
    </div>
    <div class="mx-8 my-2 float-right font-light leading-relaxed text-md text-colortext">
        <a href="mailto:{{email}}">Email: {{email}}</a>
    </div>
</div>
<div *ngIf="disableFlag" class="mt-8 overflow-hidden">
    <div class="grid grid-cols-5">
        <button
            matTooltip="In this section you will find a summary of the city with the organizational commitee, mission, objectives, orientation, groups, main actions and most relevant impacts as a result of actions' implementation"
            matTooltipClass="text-xl"
            class="mt-4 px-8 py-4 text-2xl font-light cursor-pointer bg-headerfr hover:bg-buttonhover text-yellow-200 hover:text-colortext place-self-center"
            (click)="goToDna()">
            {{city}} ID
        </button>
        <button
            class="mt-4 px-8 py-4 text-2xl font-light cursor-pointer bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400  place-self-center"
            (click)="onActions()">
            <div class="text">
                Actions
            </div>
        </button>
        <button
            matTooltip="In this section you will find the different categories of Key Performance Indicators in the city of {{city}}"
            matTooltipClass="text-xl"
            class="mt-4 px-8 py-4 text-2xl font-light cursor-pointer bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
            (click)="onKPIs()">
            <div class="text">
                KPIs
            </div>
        </button>
        <button
            class="mt-4 px-8 py-4 text-2xl font-light cursor-pointer bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
            (click)="onFormative()">
            <div class="text">
                Formative Evaluation
            </div>
        </button>
        <button
            matTooltip="In this section you will find the different FUSILLI impacts including their definition, the KPIs related to each impact and result."
            matTooltipClass="text-xl"
            class="mt-4 px-8 py-4 text-2xl font-light cursor-pointer bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
            (click)="onImpacts()">
            <div class="text">
                Impacts
            </div>
        </button>
    </div>
</div>
<div *ngIf="!disableFlag" class="mt-8 overflow-hidden">
    <div class="grid grid-cols-3">
        <button
            matTooltip="In this section you will find a summary of the city with the organizational commitee, mission, objectives, orientation, groups, main actions and most relevant impacts as a result of actions' implementation"
            matTooltipClass="text-xl"
            class="mt-4 px-8 py-4 text-2xl font-light cursor-pointer bg-headerfr hover:bg-buttonhover text-yellow-200 hover:text-colortext place-self-center"
            (click)="goToDna()">
            {{city}} ID
        </button>
        <button
            matTooltip="In this section you will find the different categories of Key Performance Indicators in the city of {{city}}"
            matTooltipClass="text-xl"
            class="mt-4 px-8 py-4 text-2xl font-light cursor-pointer bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
            (click)="onKPIs()">
            <div class="text">
                KPIs
            </div>
        </button>
        <button
            matTooltip="In this section you will find the different FUSILLI impacts including their definition, the KPIs related to each impact and result."
            matTooltipClass="text-xl"
            class="mt-4 px-8 py-4 text-2xl font-light cursor-pointer bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
            (click)="onImpacts()">
            <div class="text">
                Impacts
            </div>
        </button>
    </div>
</div>